import { render } from "./ApplicationApproval.vue?vue&type=template&id=47c1064a"
import script from "./ApplicationApproval.vue?vue&type=script&lang=js"
export * from "./ApplicationApproval.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__